export default "__VITE_ASSET__1ed78331__"